import { render, staticRenderFns } from "./adminHistory.vue?vue&type=template&id=30a3e584&"
import script from "./adminHistory.vue?vue&type=script&lang=js&"
export * from "./adminHistory.vue?vue&type=script&lang=js&"
import style0 from "./adminHistory.vue?vue&type=style&index=0&id=30a3e584&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports